export const ShopperAgentOutreachOrigin = {
  Campaign: "campaign",
  Automation: "automation",
  OutreachAgent: "outreach_agent",
  /** The shopper texted first, from the customer portal. */
  CustomerPortal: "customer_portal",
} as const;

export type ShopperAgentOutreachOrigin =
  (typeof ShopperAgentOutreachOrigin)[keyof typeof ShopperAgentOutreachOrigin];

/** campaign > automation provenance > outreach_agent (settings/sentinel). */
export function classifyShopperAgentOutreachOrigin(input: {
  readonly campaignId?: string | null;
  readonly automationId?: string | null;
  readonly automationStepId?: string | null;
  readonly recoverConfigId?: string | null;
}): ShopperAgentOutreachOrigin {
  if (input.campaignId) {
    return ShopperAgentOutreachOrigin.Campaign;
  }
  if (input.automationId || input.automationStepId || input.recoverConfigId) {
    return ShopperAgentOutreachOrigin.Automation;
  }
  return ShopperAgentOutreachOrigin.OutreachAgent;
}
